import { jsx } from 'react/jsx-runtime';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';

const WidgetPortal = ({ children, onBackdropClick, disablePadding, }) => {
    const { setMultiWalletWidgetState, accountSwitchState } = useInternalDynamicContext();
    const handleBackdropClick = (e) => {
        e.stopPropagation();
        if (accountSwitchState === 'primary_not_connected')
            return;
        setMultiWalletWidgetState('idle');
        if (!onBackdropClick)
            return;
        onBackdropClick();
    };
    return (jsx("div", Object.assign({ className: 'widget-portal', onClick: (e) => handleBackdropClick(e), "data-testid": 'backdrop' }, { children: jsx("div", Object.assign({ className: classNames('widget-portal__container', {
                'widget-portal__container--no-padding': disablePadding,
            }), onClick: (e) => e.stopPropagation() }, { children: children })) })));
};

export { WidgetPortal };
